import previewRecipes from "../data/preview-recipes.json";
import { PreviewRecipe } from "./popularRecipes";

type GetPreviewRecipesArgs = {
  week: number;
  year: number;
  preferenceId: string;
};

type PreviewRecipeEntry = {
  week: number;
  year: number;
  preferenceId: string;
  recipes: PreviewRecipe[];
};

export const getPreviewRecipes = ({
  week,
  year,
  preferenceId,
}: GetPreviewRecipesArgs): PreviewRecipe[] => {
  const data: PreviewRecipeEntry[] = previewRecipes.data;

  if (data.length === 0) {
    console.error(`PreviewRecipes data is empty`);
    return [];
  }

  let entry: PreviewRecipeEntry = data[0];

  if (week && year) {
    const e = data.find(
      (d) =>
        d.week === week && d.year === year && d.preferenceId === preferenceId,
    );

    if (!e) {
      console.error(
        `PreviewRecipes not found for week ${week} and year ${year} and preferenceId ${preferenceId}`,
      );
      return [];
    }

    entry = e;
  }

  return entry.recipes;
};
